module.exports = __webpack_public_path__ + "media/images/icons/decline-84a93ed1b54ab66349d13b7015df317c.svg";